import { cn } from '@/lib/utils';

export interface FormErrorProps {
  id?: string;
  message?: string;
  className?: string;
}

export function FormError({ id, message, className }: FormErrorProps) {
  if (!message) return null;
  return (
    <p id={id} role="alert" className={cn('mt-1 text-xs text-error', className)}>
      {message}
    </p>
  );
}
